export const facebookImages = [
    {
        url: 'https://horsedeal.imgix.net/static/social-image-1200x630.webp',
        width: 1200,
        height: 630,
    },
];

export const twitterImages = [
    {
        url: 'https://horsedeal.imgix.net/static/social-image-600x314.webp',
        width: 600,
        height: 314,
    },
];
/**
 * Get Schema object for Landing pages (other pages maybe?)
 * @param {string} schemaTitle
 * @param {string} schemaDescription
 * @returns schema object
 */
export const getLpSchemaObj = (schemaTitle, schemaDescription) => ({
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    description: schemaDescription,
    name: schemaTitle,
    image: ['https://horsedeal.imgix.net/static/social-image-1200x630.webp'],
});
